// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type KontenPage } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheKontenQuery = {
  search?: string;
  page?: number;
  limit?: number;
  sort?: string;
  filtered?: string;
};

export function useSucheKonten(): (
  query: SucheKontenQuery
) => Promise<KontenPage> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) => (await getAPI()).konten.sucheKonten({ ...query }),
    [getAPI]
  );
}
